export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            关于布丁
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网——让漫画阅读像吃布丁一样丝滑甜蜜
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-3xl p-8 md:p-10">
            <div className="flex flex-col gap-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                布丁漫画网诞生于对漫画阅读体验的极致追求。我们发现传统漫画阅读中频繁点击"下一页"的体验严重打断了阅读的沉浸感，于是首创了<strong className="text-foreground-900">布丁漫画下拉式连续阅读</strong>模式——无需翻页，只需向下滚动，就能从第1话一路读到最新话。
              </p>
              <p>
                目前布丁漫画网已收录<strong className="text-foreground-900">超过20000部布丁漫画全集</strong>，涵盖韩漫、日漫、国漫三大品类，覆盖恋爱、奇幻、悬疑、热血、搞笑、都市、穿越、修仙等热门题材。所有漫画均支持<strong className="text-foreground-900">布丁漫画下拉式免费看</strong>，无需注册，无需付费，打开即读。
              </p>
              <p>
                我们坚持每日同步更新热门连载，确保布丁漫画连续阅读模式下读者能在第一时间看到最新内容。同时持续优化阅读引擎，让<strong className="text-foreground-900">布丁漫画下拉式阅读</strong>在手机、平板和电脑上都能保持流畅稳定的体验。
              </p>
              <p>
                布丁漫画网的使命很简单：让每一个漫画爱好者，都能以最舒适的方式，读到最喜欢的布丁漫画全集。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200">
              {[
                { num: '20000+', label: '漫画全集' },
                { num: '3', label: '品类覆盖' },
                { num: '每日更新', label: '持续追更' },
                { num: '500万+', label: '月活读者' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-primary-500">
                    {stat.num}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}